export const CATEGORY = 'category/'
export const CATEGORY_ALL = `${CATEGORY}all`
